import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '../actions/global';
import * as actions from '../actions/search';

const initialState = fromJS({
  results: {
    data: [],
    state: null,
    filters: {},
    sortModel: [],
    filterModel: {},
  },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
  searchParams: {
    data: [],
    state: null,
  },
  searchParam: {
    data: {},
    state: null,
  },
  searchFormData: {},
});

const SearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SEARCH_SUCCESS: {
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['results', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          ['pagination', 'count'],
          _.get(action, 'data.totalLitigation', 0),
        );
    }
    case actions.SEARCH_START: {
      return state
        .setIn(['results', 'state'], fetchingState.FETCHING)
        .setIn(['results', 'filters'], fromJS(_.get(action, 'payload', {})))
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize);
    }
    case actions.SEARCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_SEARCH_PARAMS[START]: {
      return state.setIn(['searchParams', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SEARCH_PARAMS[SUCCESS]: {
      return state
        .setIn(['searchParams', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParams', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.DELETE_ASSIGNMENT[SUCCESS]: {
      return state
        .setIn(
          ['results', 'data'],
          fromJS(
            state
              .getIn(['results', 'data'])
              .toJS()
              .filter(r => r.mobileAssignmentID !== action.mobileAssignmentID),
          ),
        )
        .setIn(
          ['pagination', 'count'],
          state.getIn(['pagination', 'count']) - 1,
        );
    }
    case actions.FETCH_SEARCH_PARAMS[ERROR]: {
      return state.setIn(['searchParams', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_SEARCH_PARAM[START]: {
      return state.setIn(['searchParam', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SEARCH_PARAM[SUCCESS]:
    case actions.INSERT_SEARCH_PARAM[SUCCESS]:
    case actions.UPDATE_SEARCH_PARAM[SUCCESS]: {
      return state
        .setIn(['searchParam', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParam', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }
    case actions.FETCH_SEARCH_PARAM[ERROR]: {
      return state.setIn(['searchParam', 'state'], fetchingState.ERROR);
    }

    case actions.RESET_SEARCH_PARAM: {
      return state.setIn(['searchParam', 'data'], fromJS({}));
    }

    case actions.SET_SEARCH_FORM_DATA: {
      return state.setIn(['searchFormData'], fromJS(action.payload));
    }

    case actions.SET_SEARCH_PARAM: {
      return state.setIn(
        ['searchParam', 'data'],
        fromJS(
          state
            .getIn(['searchParams', 'data'])
            .toJS()
            .find(v => v.searchParamID === action.searchParamID),
        ),
      );
    }

    default: {
      return state;
    }
  }
};

export default SearchReducer;
